import { useEffect, useState, RefObject } from "react";

export const useContainerWidth = <T extends HTMLElement>(ref: RefObject<T | null>) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const updateWidth = () => {
      if (ref.current) {
        setWidth(ref.current.clientWidth);
      }
    };

    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);

  return width;
};
